import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { catchError } from 'rxjs/operators';
import _get from 'lodash-es/get';
import { NEVER } from 'rxjs';
import { RegistryDetailsService } from 'features/registry-details/registry-details.service';
import { trimValuesInObject } from 'utils/helpers';
import { OrgUserProfile } from 'interfaces/profile.interface';
import { ClientServicesService } from 'services/client-services/client-services.service';

const errorTexts = {
  requiredError: 'Please fill out all fields',
  userIdExistError: 'Internal User ID already exists',
};

@Component({
  selector: 'cm-internal-id-modal',
  templateUrl: './internal-id.modal.component.html',
  styleUrls: ['./internal-id.modal.component.scss'],
})
export class InternalIdModalComponent implements OnInit {
  @Input() profile: OrgUserProfile;
  @Input() isGlobalProfile: boolean;

  dynamicForm: UntypedFormGroup;
  showErrors: boolean;
  errors: string[] = [];
  isUpdateForm = false;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: UntypedFormBuilder,
    private registryDetailsService: RegistryDetailsService,
    private clientServicesService: ClientServicesService,
  ) {}

  ngOnInit() {
    const { organization_profile_id } = this.profile;
    this.isUpdateForm = !!organization_profile_id;
    this.dynamicForm = this.fb.group({
      organizationProfileId: [organization_profile_id],
    });
  }

  close() {
    this.activeModal.dismiss();
  }

  onSave() {
    this._resetError();
    if (this._isFormValid()) {
      const params = [String(this.profile.profile_id), trimValuesInObject(this.dynamicForm.value)];
      const request$ = this.isGlobalProfile
        ? this.clientServicesService.updateInternalId(params[0], params[1])
        : this.registryDetailsService.changeShowInRegistry(params[0], params[1]);
      request$
        .pipe(
          catchError((err) => {
            if (_get(err, 'body.code_name') === 'VALIDATION_ERROR') {
              this.showErrors = true;
              const control = this.dynamicForm.controls.organizationProfileId;
              control.setErrors({ exist: true });
              this.errors = [...this.errors, errorTexts.userIdExistError];
            }
            return NEVER;
          }),
        )
        .subscribe(() => {
          this.activeModal.close(this.dynamicForm.value);
          this.dynamicForm.reset();
        });
    } else {
      this.showErrors = true;
    }
  }

  private _resetError() {
    const control = this.dynamicForm.controls.organizationProfileId;
    const { errors } = control;
    if (errors) {
      delete errors.exist;
    }
    this.showErrors = false;
    this.errors = [];
  }

  private _isFormValid(): boolean {
    if (this.dynamicForm.valid) {
      return true;
    } else {
      const requiredError = !!Object.values(this.dynamicForm.controls).find((control) => {
        const { errors } = control;
        return errors && errors.required;
      });

      if (requiredError) {
        this.errors = [...this.errors, errorTexts.requiredError];
      }
      return false;
    }
  }
}
